export default __webpack_public_path__ + "static/media/vertical_back.94d7c5bc.png";